import { render } from "./DashboardPagos.vue?vue&type=template&id=5745013f"
import script from "./DashboardPagos.vue?vue&type=script&lang=js"
export * from "./DashboardPagos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__